import { IconButton } from '@mui/material';
import { CustomTooltip } from 'src/components/tooltip/CustomTooltip';

export interface LocationGroupActionButton {
  title: string;
  ariaLabel: string;
  icon: JSX.Element;
  onClick: () => void;
}

interface LocationGroupActionButtonsProps {
  items: LocationGroupActionButton[];
}

export const LocationGroupActionButtons = ({
  items,
}: LocationGroupActionButtonsProps) => (
  <>
    {items.map((item) => (
      <CustomTooltip
        key={item.title}
        title={item.title}
        placement="top"
        skipValidateOverflow={true}>
        <IconButton aria-label={item.ariaLabel} onClick={item.onClick}>
          {item.icon}
        </IconButton>
      </CustomTooltip>
    ))}
  </>
);
